import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24 } = props
  return (
    <svg height={height} width={width} {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_929_2409)">
        <path d="M10.6666 9.33325C10.6666 9.88552 11.1144 10.3333 11.6666 10.3333C12.2189 10.3333 12.6666 9.88552 12.6666 9.33325C12.6666 8.78099 12.2189 8.33325 11.6666 8.33325C11.1144 8.33325 10.6666 8.78099 10.6666 9.33325Z" stroke="#72808F" />
        <path d="M12.6 5.33325C12.6437 5.11785 12.6667 4.8949 12.6667 4.66659C12.6667 2.82564 11.1743 1.33325 9.33333 1.33325C7.4924 1.33325 6 2.82564 6 4.66659C6 4.8949 6.02295 5.11785 6.06668 5.33325" stroke="#72808F" />
        <path d="M4.66671 5.32891H10.6667C12.5523 5.32891 13.4951 5.32891 14.0809 5.91497C14.6667 6.50105 14.6667 7.44428 14.6667 9.33082V10.6648C14.6667 12.5513 14.6667 13.4946 14.0809 14.0807C13.4951 14.6667 12.5523 14.6667 10.6667 14.6667H6.66671C4.15255 14.6667 2.89547 14.6667 2.11442 13.8853C1.33337 13.1039 1.33337 11.8462 1.33337 9.33082V7.99688C1.33337 5.48149 1.33337 4.2238 2.11442 3.44237C2.74315 2.81335 3.68033 2.69067 5.33337 2.66675H6.66671" stroke="#72808F" strokeLinecap="round" />
      </g>
      <defs>
        <clipPath id="clip0_929_2409">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>

  )
}

export default SvgComponent
